import { workspacePrefix } from "./workspaceAssertion";
const prefix = workspacePrefix(window.location.pathname);
if (prefix) {
  // Webpack uses this for lazy JS/CSS chunks after the prefixed initial HTML.
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = prefix + "/";
}
